import React from 'react'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
const Vaccinations = () => {
  return (
    <main>
      <Navbar />
      <Footer />
    </main>
  );
}

export default Vaccinations
